import {
    AREAS_LIST,
    AREAS_LIST_SUCCESS,
    AREAS_LIST_ERROR,
    AREAS_DDLIST,
    AREAS_DDLIST_SUCCESS,
    AREAS_DDLIST_ERROR,
} from '../types';

const initialState = {
    areas: [],
    area: {},
    loading: false,
    error: false
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case AREAS_LIST:
            return {
                ...state,
                loading: true,
                area: {},
            }
        case AREAS_LIST_SUCCESS:
            return {
                ...state,
                areas: action.payload,
                area: {},
                loading: false,
                error: false,
            }
        case AREAS_LIST_ERROR:
            return {
                ...state,
                areas: [],
                area: {},
                loading: false,
                error: true,
            }
        case AREAS_DDLIST:
            return {
                ...state,
                loading: true,
                area: {}
            }
        case AREAS_DDLIST_SUCCESS:
            return {
                ...state,
                areas: action.payload,
                loading: false,
                error: false
            }
        case AREAS_DDLIST_ERROR:
            return {
                ...state,
                areas: [],
                loading: false,
                error: true,
                area: {}
            }
        default:
            return state;
    }
}
